import Storage from '@common/Storage/Storage'

import globals from '@ugyesedni/appShell/globals'

const sessionStorage = new Storage(globals.serial, 'session')

export default sessionStorage
